/* unplugin-vue-components disabled */import script from "./message-plugin-layout.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin-layout.vue?vue&type=script&lang=ts&setup=true"

import "./message-plugin-layout.vue?vue&type=style&index=0&id=6686ba0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6686ba0e"]])

export default __exports__